import React, { Component } from "react";
import PolicyNav from "../../components/policyNav/PolicyNav";
import PolicyPanel from "../../components/policyPanel/PolicyPanel";
import DistrictOverview from "../../components/districtOverview/DistrictOverview";
import DistrictEngagement from "../../components/districtEngagement/DistrictEngagement";

class DistrictDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      districtName: "",
      Total: null,
    };
  }

  componentWillReceiveProps() {
    switch (window.location.href.split("/")[5]) {
      case "corbusville":
        this.setState({ districtName: "Corbusville" });
        break;
      case "jacobs_hill":
        this.setState({ districtName: "Jacobs Hill" });
        break;
      case "downtown":
        this.setState({ districtName: "Downtown" });
        break;
      case "howard_gardens":
        this.setState({ districtName: "Howard Gardens" });
        break;
      case "moses_gulch":
        this.setState({ districtName: "Moses Gulch" });
        break;
        default:
          break;
    }
  }

  componentWillMount() {
    switch (window.location.href.split("/")[5]) {
      case "corbusville":
        this.setState({ districtName: "Corbusville" });
        break;
      case "jacobs_hill":
        this.setState({ districtName: "Jacobs Hill" });
        break;
      case "downtown":
        this.setState({ districtName: "Downtown" });
        break;
      case "howard_gardens":
        this.setState({ districtName: "Howard Gardens" });
        break;
      case "moses_gulch":
        this.setState({ districtName: "Moses Gulch" });
        break;
        default:
          break;
    }
  }

  // onNavSelect = id => {
  //   console.log("Inside District Dashboard, id:  ", id);
  //   this.setState({ policyNavSelection: id, subPolicy: "" });
  //   sessionStorage.setItem("policyheading", id.toLowerCase());
  // };

  setZones = (Commercial, Green, Mixed, Residential, Parking) => {
    if (Commercial && Green && Mixed && Residential && Parking) {
      // console.log(Commercial + Green + Mixed + Residential + Parking)
      this.setState({
        Total: Commercial + Green + Mixed + Residential + Parking
      });
    }
  };

  render() {
    let districtNav;
    if (window.location.href.split("/")[6] === "overview") {
      districtNav = (
        <DistrictOverview
          districtName={this.state.districtName}
          student_is_manager={this.props.student_is_manager}
          metricsJSON={this.props.metricsJSON}
          forecastJSON={this.props.forecastJSON}
          onPlotChange1={this.props.onPlotChange1}
          onPlotChange2={this.props.onPlotChange2}
          metricsSelections={this.props.metricsSelections}
          costSelections={this.props.costSelections}
          revenueSelections={this.props.revenueSelections}
          selectedMetric1={this.props.selectedMetric1}
          selectedMetric2={this.props.selectedMetric2}
          combinedPlotData1={this.props.combinedPlotData1}
          combinedPlotData2={this.props.combinedPlotData2}
          selectionAvailable={this.props.selectionAvailable}
          plotType1={this.props.plotType1}
          plotType2={this.props.plotType2}
          selectedPlotData1={this.props.selectedPlotData1}
          selectedPlotData2={this.props.selectedPlotData2}
          cityCurrent={this.props.cityCurrent}
          suspendButton={this.props.suspendButton}
          combinedDistrictPlotData={this.props.combinedDistrictPlotData}
          selectedDistrictPlotData={this.props.selectedDistrictPlotData}
          selectedForecastDistrictPlotData={this.props.selectedForecastDistrictPlotData}
          onDistrictPlotChange={this.props.onDistrictPlotChange}
          districtPlotType={this.props.districtPlotType}
          selectedDistrictMetric={this.props.selectedDistrictMetric}
          districtCurrent={this.props.districtCurrent}
        />
      );
    } else if (window.location.href.split("/")[6] === "engagement") {
      districtNav = (<DistrictEngagement
        policyHeader={this.props.policyNavSelection}
        districtName={this.state.districtName}
        engagementFunc={this.props.engagementFunc}
        setEngagement={this.props.setEngagement}
        InformObj={this.props.InformObj}
        ConsultObj={this.props.ConsultObj}
        InvolveObj={this.props.InvolveObj}
        CollaborateObj={this.props.CollaborateObj}
        Inform={this.props.Inform}
        Consult={this.props.Consult}
        Involve={this.props.Involve}
        Collaborate={this.props.Collaborate}
        InformSubmitted={this.props.InformSubmitted}
        ConsultSubmitted={this.props.ConsultSubmitted}
        InvolveSubmitted={this.props.InvolveSubmitted}
        CollaborateSubmitted={this.props.CollaborateSubmitted}
        engageObj={this.props.engageObj}
        setTotalEngagement={this.props.setTotalEngagement}
        suspendButton={this.props.suspendButton}
        onsubmitSyncToClients={this.props.onsubmitSyncToClients}
        engagementData={this.props.engagementData}
        engagementSubPolicy={this.props.engagementSubPolicy}
        districtEngagementData={this.props.districtEngagementData}
        onEngagementClickHandler={this.props.onEngagementClickHandler}
        ConsultDisabled={this.props.ConsultDisabled}
        InvolveDisabled={this.props.InvolveDisabled}
        CollaborateDisabled={this.props.CollaborateDisabled}
        InformTarget={this.props.InformTarget}
        InformLock={this.props.InformLock}
        InformMax={this.props.InformMax}
        InformMaxReached={this.props.InformMaxReached}
        ConsultTarget={this.props.ConsultTarget}
        ConsultLock={this.props.ConsultLock}
        ConsultMax={this.props.ConsultMax}
        ConsultMaxReached={this.props.ConsultMaxReached}
        InvolveTarget={this.props.InvolveTarget}
        InvolveLock={this.props.InvolveLock}
        InvolveMax={this.props.InvolveMax}
        InvolveMaxReached={this.props.InvolveMaxReached}
        CollaborateTarget={this.props.CollaborateTarget}
        CollaborateLock={this.props.CollaborateLock}
        CollaborateMax={this.props.CollaborateMax}
        CollaborateMaxReached={this.props.CollaborateMaxReached}
        onEngagementSubmitHandler={this.props.onEngagementSubmitHandler}
        onEngagementSelectHandler={this.props.onEngagementSelectHandler}
        currentYear={this.props.currentYear}
        fact_sheets={this.props.fact_sheets}
        website={this.props.website}
        newsletter={this.props.newsletter}
        open_house={this.props.open_house}
        surveys={this.props.surveys}
        focus_groups={this.props.focus_groups}
        public_meetings={this.props.public_meetings}
        public_forums={this.props.public_forums}
        utilizing_social_media={this.props.utilizing_social_media}
        deliberative_polling={this.props.deliberative_polling}
        workshops={this.props.workshops}
        charrettes={this.props.charrettes}
        consensus_building={this.props.consensus_building}
        citizens_juries={this.props.citizens_juries}
        advisory_board={this.props.advisory_board}
        engagementSubmitPrevent={this.props.engagementSubmitPrevent}
        engagementSuspended={this.props.engagementSuspended}
        disabledButton={this.props.disabledButton}
        engagementToolTipMessage={this.props.engagementToolTipMessage}
        />)
    } else {
      districtNav = (
        <PolicyPanel
          districtName={this.state.districtName}
          policyHeader={this.props.policyNavSelection}
          subPolicy={this.props.districtSubPolicy}
          setZones={this.props.setZones}
          student_is_manager={this.props.student_is_manager}
          engagementFunc={this.props.engagementFunc}
          setTotalEngagement={this.props.setTotalEngagement}
          setEngagement={this.props.setEngagement}
          metricsJSON={this.props.metricsJSON}
          forecastJSON={this.props.forecastJSON}
          onPlotChange1={this.props.onPlotChange1}
          onPlotChange2={this.props.onPlotChange2}
          metricsSelections={this.props.metricsSelections}
          costSelections={this.props.costSelections}
          revenueSelections={this.props.revenueSelections}
          selectedMetric1={this.props.selectedMetric1}
          selectedMetric2={this.props.selectedMetric2}
          combinedPlotData1={this.props.combinedPlotData1}
          combinedPlotData2={this.props.combinedPlotData2}
          selectionAvailable={this.props.selectionAvailable}
          plotType1={this.props.plotType1}
          plotType2={this.props.plotType2}
          selectedPlotData1={this.props.selectedPlotData1}
          selectedPlotData2={this.props.selectedPlotData2}
          cityCurrent={this.props.cityCurrent}
          suspendButton={this.props.suspendButton}
          combinedDistrictPlotData={this.props.combinedDistrictPlotData}
          selectedDistrictPlotData={this.props.selectedDistrictPlotData}
          selectedForecastDistrictPlotData={this.props.selectedForecastDistrictPlotData}
          onDistrictPlotChange={this.props.onDistrictPlotChange}
          districtPlotType={this.props.districtPlotType}
          selectedDistrictMetric={this.props.selectedDistrictMetric}
          remainingForecastAttempts={this.props.remainingForecastAttempts}
          onDistrictPolicyClickHandler={this.props.onDistrictPolicyClickHandler}
          districtSubPolicyDefaultValue={this.props.districtSubPolicyDefaultValue}
          districtSubPolicyPrevtValue={this.props.districtSubPolicyPrevtValue}
          onDistrictSubmitHandler={this.props.onDistrictSubmitHandler}
          onPageClick={this.props.onPageClick}
          start={this.props.start}
          stop={this.props.stop}
          onZoneChange={this.props.onZoneChange}
          districtPolicyData={this.props.districtPolicyData}
          Commercial={this.props.Commercial}
          Green={this.props.Green}
          Mixed={this.props.Mixed}
          Residential={this.props.Residential}
          Parking={this.props.Parking}
          corbusville={this.props.corbusville}
          downtown={this.props.downtown}
          howard_gardens={this.props.howard_gardens}
          jacobs_hill={this.props.jacobs_hill}
          moses_gulch={this.props.moses_gulch}
          onDistrictSelectHandler={this.props.onDistrictSelectHandler}
          currentYear={this.props.currentYear}
          previousYear={this.props.previousYear}
          setDistrictDefaults={this.props.setDistrictDefaults}
          disabledButton={this.props.disabledButton}
          parkingZone={this.props.parkingZone}
          submitting={this.props.submitting}
          onForecastSubmit={this.props.onForecastSubmit}
          forecasting={this.props.forecasting}
          districtSubmitPrevent={this.props.districtSubmitPrevent}
          toolTipMessage={this.props.toolTipMessage}
          policySuspended={this.props.policySuspended}
        />
      );
    }

    return (
      <div className={`${this.props.display === "show" ? "active" : "hidden"}`}>
        {/* <h1>District Name: {this.state.districtName}</h1> */}
        <PolicyNav
          onNavSelect={this.props.onNavSelect}
          districtName={this.state.districtName}
          Total={this.props.Total}
          Commercial={this.props.Commercial}
          Green={this.props.Green}
          Mixed={this.props.Mixed}
          Residential={this.props.Residential}
          parkingZone={this.props.parkingZone}
          policyHeader={this.props.policyNavSelection}
        />
        {districtNav}
      </div>
    );
  }
}

export default DistrictDashboard;
